import { useCallback } from "react";

/**
 * onValuesChange handler to sync allow/deny groups:
 * - All Rights / No Rights toggles (unchanged)
 * - Individual exclusivity across groups (unchanged)
 * - when any individual is manually unchecked, uncheck All Rights in that same group
 */
export function usePermissionSync(form, permissionItems) {
  const allConst = permissionItems.find(i => i.defaultString === "All Rights")?.constantName;
  const noneConst = permissionItems.find(i => i.defaultString === "No Rights")?.constantName;

  return useCallback((changed, allValues) => {
    // Handle All Rights / No Rights toggles (your existing logic)
    console.log({ changed, allValues, form, permissionItems }, "usePermissionSync");

    ["allowSetting", "denySetting"].forEach(field => {
      const group = changed[field];
      if (!group) return;
      const opposite = field === "allowSetting" ? "denySetting" : "allowSetting";

      // All Rights
      if (allConst in group) {
        const checked = group[allConst];
        if (checked) {
          // check every individual (except No Rights)
          form.setFieldsValue({
            [field]: permissionItems.reduce((acc, i) => {
              acc[i.constantName] = i.constantName !== noneConst;
              return acc;
            }, {}),
            // in opposite, only leave No Rights
            [opposite]: permissionItems.reduce((acc, i) => {
              acc[i.constantName] = i.constantName === noneConst;
              return acc;
            }, {}),
          });
        } else {
          // only clear All Rights, leave other settings intact
          form.setFieldsValue({
            [field]: {
              ...allValues[field],
              [allConst]: false,
            },
          });
        }
      }
      // No Rights
      else if (noneConst in group && group[noneConst]) {
        form.setFieldsValue({
          // clear this group completely
          [field]: permissionItems.reduce((acc, i) => {
            acc[i.constantName] = i.constantName === noneConst;
            return acc;
          }, {}),
          // in opposite, check every individual (except No Rights)
          // [opposite]: permissionItems.reduce((acc, i) => {
          //   if(acc[i.constantName]!=noneConst)
          //   acc[i.constantName] = false
          //   return acc;
          // }, {}),
        });
      }
    });

    // Cross‐group individual exclusivity
    // ["allowSetting", "denySetting"].forEach(src => {
    //   const tgt = src === "allowSetting" ? "denySetting" : "allowSetting";
    //   const grp = changed[src];
    //   if (!grp) return;

    //   const updates = {};
    //   Object.entries(grp).forEach(([cn, on]) => {
    //     console.log({ cn, on, allConst, noneConst, grp,tgt,changed })
    //     if (cn !== allConst && cn !== noneConst) {
    //       updates[cn] = !on;
    //     }
    //   });
    //   console.log({updates})
    //   if (Object.keys(updates).length) {
    //     console.log({ updates, allVal: allValues[tgt], tgt })

    //     form.setFieldsValue({
    //       [tgt]: {
    //         ...allValues[tgt],
    //         [allConst]: false, // uncheck All Rights in opposite
    //         ...updates,
    //       },
    //     });
    //   }
    //   console.log(form.getFieldsValue(),"formVals")
    // });

    // when any individual in a group is unchecked,
    // uncheck All Rights in that same group
    ["allowSetting", "denySetting"].forEach(field => {
      const grp = changed[field];
      if (!grp) return;
      const anyUnchecked = Object.entries(grp).some(
        ([cn, on]) => on === false && cn !== allConst && cn !== noneConst
      );
      if (anyUnchecked) {
        form.setFieldsValue({
          [field]: {
            ...allValues[field],
            [allConst]: false,
          },
        });
      }
    });

  }, [form, permissionItems, allConst, noneConst]);
}
